import { all } from 'redux-saga/effects'
import { removeSaga } from './remove/saga'
import { uploadSaga } from './upload/saga'

export function* companyBannerSaga() {
  yield all([uploadSaga(), removeSaga()])
}
